import { render } from "./LivingLabSelection.vue?vue&type=template&id=1ce225bd&scoped=true"
import script from "./LivingLabSelection.vue?vue&type=script&lang=js"
export * from "./LivingLabSelection.vue?vue&type=script&lang=js"

import "./LivingLabSelection.vue?vue&type=style&index=0&id=1ce225bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce225bd"]])

export default __exports__